module.exports = __webpack_public_path__ + "media/v2/components/shared/Image/plus_svg-581c3ac4b1f14855732d4f47aafd478b.svg";